module.exports = __webpack_public_path__ + "img/psychologue-f.61aa57a4.jpg";